import contentSubmissionFetchers from '@/api/fetchers/contentSubmission';
import useDataQuery from '@/hooks/use-data-query';

function useContentSubmissionVersionQuery({
  contentSubmissionVersionId,
  enabled = true,
}: {
  contentSubmissionVersionId: string | undefined;
  enabled?: boolean;
}) {
  return useDataQuery({
    queryKey: ['contentSubmissionVersion', contentSubmissionVersionId],
    queryFn: contentSubmissionFetchers.contentSubmissionVersion,
    enabled: !!contentSubmissionVersionId && enabled,
    meta: {
      contentSubmissionVersionId,
    },
  });
}
export default useContentSubmissionVersionQuery;
